import { CollapsibleFieldList } from "../../../parts/CollapsibleFieldList";
import { OptionalFieldGroup } from "../../../parts/FieldGroup";

interface HomePageSettingsProps {
  enabled: boolean;
  onEnabledChange: (nextValue: boolean) => void;
}

export function HomePageSettings({
  enabled,
  onEnabledChange,
}: HomePageSettingsProps) {
  return (
    <CollapsibleFieldList title={"Home Page"} defaultOpen>
      <OptionalFieldGroup
        label={"Enable Home Page"}
        description={"Enable the home page of the Quack Home."}
        enabled={enabled}
        toggleEnabled={onEnabledChange}
      />
    </CollapsibleFieldList>
  );
}
